import { Suspense, lazy } from "react";
import { useSprint26FlagVisible } from "../lib/featureFlags.js";

/**
 * E-BUNDLE-14 — Ladeschranke vor der Global-Search-Palette.
 *
 * `AppShell` haengt drei Overlays fest in den Startpfad, obwohl keines davon
 * beim ersten Paint etwas zeichnen kann: alle drei haengen an einem
 * Sprint-26-Flag der Klasse `internal_admin_only` (Default OFF), und
 * `useSprint26FlagVisible` liest dieses Flag ueber eine Query — vor deren
 * Antwort ist `visible` immer `false`. Die Palette lag damit mit rund 4,1 kB
 * generiertem Code im Entry-Chunk und wartete auf eine Sichtbarkeit, die in
 * aller Regel nie eintritt.
 *
 * Diese Schranke prueft dasselbe Flag und laedt das Modul erst, wenn es
 * sichtbar ist. Weil das Flag ohnehin erst nach einem Netz-Roundtrip
 * feststeht, kostet der zusaetzliche Chunk-Load keinen sichtbaren Moment: er
 * laeuft in genau dem Fenster, in dem die Palette vorher schon `null`
 * gerendert haette. Verhalten und Shortcut bleiben unveraendert — die
 * Komponente selbst ist nicht angefasst und prueft das Flag weiterhin selbst.
 */
const GlobalSearchPalette = lazy(async () => {
  const mod = await import("./GlobalSearchPalette.js");
  return { default: mod.GlobalSearchPalette };
});

export function GlobalSearchPaletteGate() {
  const { visible } = useSprint26FlagVisible("sprint26.globalSearch");
  if (!visible) return null;
  return (
    <Suspense fallback={null}>
      <GlobalSearchPalette />
    </Suspense>
  );
}
